import React from 'react';
import { AlertCircle, X } from 'lucide-react';

const ErrorMessage = ({
  message,
  onDismiss,
  className = '',
  ...props
}) => {
  if (!message) return null;

  return (
    <div className={`bg-red-50 border border-red-200 rounded-md p-4 ${className}`} {...props}>
      <div className="flex">
        <AlertCircle size={20} className="text-red-400 flex-shrink-0 mt-0.5" />
        <div className="ml-3 flex-1">
          <p className="text-sm text-red-700">{message}</p>
        </div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="ml-auto flex-shrink-0 text-red-400 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 rounded-md p-1"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;